import { takeEvery, fork } from 'redux-saga/effects';
import { commentsModel } from '../index';

export function* commentsWorker() {
  yield takeEvery(
    commentsModel.actions.updateThreadStatus,
    commentsModel.sagas.updateThreadStatus
  );
  yield takeEvery(
    commentsModel.actions.updateCommentContent,
    commentsModel.sagas.updateCommentContent
  );
  yield takeEvery(
    commentsModel.actions.deleteThread,
    commentsModel.sagas.deleteThread
  );
  yield takeEvery(
    commentsModel.actions.deleteComment,
    commentsModel.sagas.deleteComment
  );

  yield takeEvery(
    commentsModel.actions.startCommentingFlow,
    commentsModel.sagas.createCommentFlow
  );

  yield takeEvery(
    commentsModel.actions.setSelectedThreads,
    commentsModel.sagas.setSelectedThreads
  );

  yield takeEvery(
    commentsModel.actions.createCommentReply,
    commentsModel.sagas.createCommentReply
  );

  yield fork(commentsModel.sagas.watchPreviewStatus);
}
